import StepsCTA from 'components/HappeningNonContent/ServiceBooking/StepsCTA/StepsCTA';

export default StepsCTA;
